import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import store from './store';
import './styles/main.css';

// Allow deploying the same build under a path (e.g. /cars/) or at root.
// Set VITE_BASE_PATH=/cars at build time for path-based deploy.
const BASENAME = (import.meta.env && import.meta.env.BASE_URL) ? import.meta.env.BASE_URL.replace(/\/$/, '') : '';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={BASENAME}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
